/*
 * Application Insights JavaScript SDK - Common, 2.7.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
import { __extendsFn as __extends } from "@microsoft/applicationinsights-shims"; // THIS FILE WAS AUTOGENERATED

import { PageViewData } from "./PageViewData";
/**
 * An instance of PageViewPerf represents: a page view with no performance data, a page view with performance data, or just the performance data of an earlier page request.
 */

var PageViewPerfData =
/** @class */
function (_super) {
  __extends(PageViewPerfData, _super);

  function PageViewPerfData() {
    var _this = _super.call(this) || this;
    /**
     * Schema version
     */


    _this.ver = 2;
    /**
     * Collection of custom properties.
     */

    _this.properties = {};
    /**
     * Collection of custom measurements.
     */

    _this.measurements = {};
    return _this;
  }

  return PageViewPerfData;
}(PageViewData);

export { PageViewPerfData };